<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>活动</el-breadcrumb-item>
			<el-breadcrumb-item>活动列表</el-breadcrumb-item>
		</el-breadcrumb>
		<el-button style="margin: 10px 0 20px;" type="success" @click="goto">+ 添加活动文章</el-button>
		<el-card>
			<!-- 表格数据 -->
			<el-table :data="huodongList" border :strip="true">
				<el-table-column label="ID" width="70px" prop="id"></el-table-column><!-- type="index" -->
				<el-table-column label="标题" prop="title"></el-table-column>
				<el-table-column label="封面图">
					<template slot-scope="scope">
						<img :src="$imgTitle+scope.row.coverPicture" alt="" style="width: 200px;height: 119px;"/>
					</template>
				</el-table-column>
				<el-table-column label="所属分类" width="100px">
					<template slot-scope="scope">
						活动
					</template>
				</el-table-column>
				<el-table-column label="权重" width="70px" prop="weights"></el-table-column>
				<el-table-column label="添加时间" prop="createTime">
					<template slot-scope="scope">{{scope.row.createTime | dataFormat }}</template>
				</el-table-column>
				<!-- <el-table-column label="商品数量" prop="goods_number" width="70px"></el-table-column>
			  <el-table-column label="创建时间" prop="add_time" width="140px">
			    <template slot-scope="scope">{{scope.row.add_time | dataFormat }}</template>
			  </el-table-column> -->
				<el-table-column label="操作">
					<!-- width="130px" -->
					<template slot-scope="scope">
						<!-- <el-button type="primary" icon="el-icon-edit" size="mini"></el-button>
			      <el-button
			        type="danger"
			        icon="el-icon-delete"
			        size="mini"
			        @click="removeById(scope.row.goods_id)"
			      ></el-button> -->
						<el-button type="primary" size="mini" @click="gotoEdit(scope.row.id)">编辑</el-button>
						<el-button type="danger" size="mini" @click="delHuodong(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.request.pageNo"
			 :page-size="queryInfo.request.pageSize" layout="total, prev, pager, next, jumper" :total="total" background></el-pagination>


			
		</el-card>
	</div>


</template>

<script>
	/* import HelloWorld from '@/components/HelloWorld.vue' */
	export default {
		name: 'Home',
		data() {
			return {
				queryInfo: {
					request: {
						type: 1, //活动 1 资讯 2
						pageNo: 1,
						pageSize: 5
					}
				},
				huodongList: [],
				total: 0
			}
		},
		components: {

		},
		created() {
			var data = {
				"data": {
					"code": 0,
					"message": "success.",
					"data": {
						"pageNo": 1,
						"totalNum": 4,
						"totalPage": 1,
						"list": [{
							"id": 12,
							"title": "新品上市 | 慕茹姬氨基酸洗面奶，深彻清洁面部肌肤，敏感肌救星 ",
							"introduction": "化妆不洗脸，变成痘痘脸~\r\n洁面的重要性想必大家都知道\r\n就算平时很少化妆\r\n但是每日接触的粉尘雾霾等\r\n如果清洁不彻底的话\r\n也是造成皮肤暗沉、黑头的主要原因\r\n所以认真洁面很重要！！",
							"weights": 12,
							"coverPicture": "activityNewInfo/202006151134177453887.gif",
							"createTime": "1588217780"
						}, {
							"id": 11,
							"title": "喜讯｜2020年九航集团股东合伙人制度全新升级，合力共赢未来！",
							"introduction": "喜家德的创始人高德福常说：“你能取得多大成功，取决于多少人相信并跟着你走。”他创建的“358合伙人制度”，稳定了内部人才，而且员工干劲十足，喜家德一跃成为行业黑马。",
							"weights": 11,
							"coverPicture": "activityNewInfo/202006151113307889640.jpg",
							"createTime": "1585624158"
						}, {
							"id": 10,
							"title": "【九航云选APP】“9.9元抢购智能体脂秤”活动火爆，还有众多福",
							"introduction": "【九航云选APP】“9.9元抢购智能体脂秤”活动火爆，还有众多福利等你来拿~",
							"weights": 10,
							"coverPicture": "activityNewInfo/202006151027465644971.jpg",
							"createTime": "1592188242"
						}, {
							"id": 1,
							"title": "培训｜九航集团举行专题培训，提升跨部门沟通和冲突管理 ",
							"introduction": "2020年4月13日下午，为提升干部的管理水平，迎接新挑战，迈向新征程，九航集团在总部组织举行一场主题为“跨部门沟通与冲突管理”的培训会，九航集团旗下各子公司及部门负责人、团队干部等部参加了此次培训。",
							"weights": 1,
							"coverPicture": "%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20200612115817.jpg",
							"createTime": "1588233890"
						}]
					}
				},
				"status": 200,
				"statusText": "",
				"headers": {
					"access-control-allow-origin": "*",
					"date": "Sat, 27 Jun 2020 09:38:51 GMT",
					"vary": "Origin, Access-Control-Request-Method, Access-Control-Request-Headers",
					"transfer-encoding": "chunked",
					"content-type": "application/json;charset=UTF-8"
				},
				"config": {
					"url": "/v1/official/news/activity/page",
					"method": "post",
					"data": "{\"request\":{\"type\":1,\"pageNo\":1,\"pageSize\":5}}",
					"headers": {
						"Accept": "application/json, text/plain, */*",
						"Content-Type": "application/json;charset=utf-8"
					},
					"baseURL": "http://120.24.239.84:8701",
					"transformRequest": [null],
					"transformResponse": [null],
					"timeout": 0,
					"xsrfCookieName": "XSRF-TOKEN",
					"xsrfHeaderName": "X-XSRF-TOKEN",
					"maxContentLength": -1
				},
				"request": {}
			}
			this.getList()
			
		
		},
		methods: {
			async getList() {
				const res = await this.$http.post('/v1/official/manag/newsActivityListInfo', this.queryInfo) //查询活动资讯（分页）
				console.log(JSON.stringify(res))

				if (res.data.code == 0) {
					this.huodongList = res.data.data.list;
					this.total = res.data.data.totalNum
				}else if(res.data.code == 102){
					this.$router.push({
						path:'/login'
					})
				}
			},
			handleSizeChange(newSize) {
				this.queryInfo.request.pageSize = newSize
				this.getList()
			},
			handleCurrentChange(newSize) {
				this.queryInfo.request.pageNo = newSize
				this.getList()
			},
			goto() {
				/* this.$router.push('/addhuodong', query: {
					id: 110
				}) */
				this.$router.push({
				    path:"/addhuodong",//这个path就是你在router/index.js里边配置的路径
				})
			},
			gotoEdit(id){
				console.log(id)
				this.$router.push({
				    path:"/edithuodong",//这个path就是你在router/index.js里边配置的路径
				    query:{
				          id:id
				    }
				})
			},
			async delHuodong(id){
				console.log(id)
				const confirmResult = await this.$confirm(
				  '此操作将删除该文章, 是否继续?',
				  '提示',
				  {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				  }
				).catch(err => err)
				if (confirmResult !== 'confirm') {
				  return this.$message.info('已取消删除！')
				}//资讯/资讯删除接口 v1/official/manag/deleteActivityById  post接口 参数 int id
				var res = await this.$http.get('/v1/official/manag/deleteActivityById',{
							params:{
								id:id
							}
				})
				console.log(JSON.stringify(res))
				if(res.data.code == 0){
					this.$message.success('删除成功');
					this.getList();
				}else{
					this.$message.error(res.data.message)
				}
			}
		}
	}
</script>

<style lang="less" scoped>

</style>
